const enrollSuccess = {
  path: 'enrollSuccess',
  props: true,
  component: resolve => require(['../../../../../components/pages/student_user/homeClass/classEnroll/enrollSuccess'], resolve)
}
export default enrollSuccess



// WEBPACK FOOTER //
// ./src/router/pages/student_user/homeClass/classEnroll/enrollSuccess.js